<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaUnidadesAtendimento"
        title-table="Unidades de Atendimento"
        module="unidadeAtendimentoSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_UNIDADE_ATENDIMENTO_INSERIR"
        view-permission="ROLE_UNIDADE_ATENDIMENTO_CONSULTAR"
        edit-permission="ROLE_UNIDADE_ATENDIMENTO_ATUALIZAR"
        delete-permission="ROLE_UNIDADE_ATENDIMENTO_DELETAR"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormUnidadeAtendimento
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormUnidadeAtendimento from './forms/FormUnidadeAtendimento.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormUnidadeAtendimento,
  },

  computed: {
    ...mapState('unidadeAtendimentoSettingsModule', {
      listaUnidadesAtendimento: state => state.listaUnidadesAtendimento,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch(
        'unidadeAtendimentoSettingsModule/resetUnidadeAtendimento',
      )
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'unidadeAtendimentoSettingsModule/prepareToEditUnidadeAtendimento',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
